import React, {Component} from 'react';
import {connect} from 'react-redux';
import RequiredRadioGroup from '../common/form/elements/required-radio-group';
import {getMarketingConsent} from '../../actions/marketing_consent';
import {tradeSiteEnabled} from '../../utils/toggles';

const styles = {
  paddingBottom: 30,
  textAlign: 'left'
};

class MarketingPreferences extends Component {
  componentWillMount() {
    if (!this.props.invitation) {
      let params = {};
      if (this.props.customer_number) {
        params = {params: {customer_unique_number: this.props.customer_number}};
      }
      this.props.dispatch(getMarketingConsent(params));
    }
  }

  options = [
    {
      label: 'Yes',
      value: 'true',
    },
    {
      label: 'No',
      value: 'false',
    }
  ];

  optionsConfirm = [
    {
      label: (<strong>I've changed my mind, keep me updated</strong>),
      value: 'true',
    },
    {
      label: (<div style={ { fontSize: '0.9em' } }>No, I don't want to be kept up to date</div>),
      value: 'false',
    }
  ];

  marketingPreferences = (
    <div>
        You must update your contact preferences below so that we are able to keep you up to date with
        important <strong>ignite</strong> updates such as; ways of earning points, product pricing, competitions & prize draws and
        local POR deals.
      <br />
      <br />
      <strong>By opting out you may reduce your potential for earning maximum ignite points.</strong>
    </div>
  )

  render() {
    const {
      title, type, formData, marketingConsentText, marketingConsentCondition
    } = this.props;

    let marketingPreferences = (
      <div>
          You must update your contact preferences below so that we are able to keep you up to date with
          important <strong>ignite</strong> updates such as; ways of earning points, product pricing, competitions & prize draws and
          local POR deals.
        <br />
        <br />
        <strong>By opting out you may reduce your potential for earning maximum ignite points.</strong>
      </div>
    );

    if (tradeSiteEnabled()) {
      marketingPreferences = (
        <div className={marketingConsentCondition} >
          {
              (marketingConsentText) ? (
                <div dangerouslySetInnerHTML={{__html: marketingConsentText}}></div>
              ) : null
            }
        </div>
      );
    }

    return (
      <div style={styles}>
        {title}
        {marketingPreferences}
        <br/>
        <RequiredRadioGroup model=".marketing_accepted" controlId="marketing_preferences" radios={this.options}/>
        <div>
          Please note that your marketing preferences will not impact ignite programme service notifications,
          we will still let you know about important updates and changes to the programme.
        </div>
        {type === 'popup' && formData && formData.marketing_accepted === 'false' && (
          <div>
            <strong>Are you sure?</strong>
            <br />
            <br />
            <div>
                  By no longer receiving <strong>ignite</strong> communications you’ll potentially be restricting your maximum
                  earning potential and miss out on critical industry and programme information.
            </div>
            <RequiredRadioGroup model=".marketing_accepted_confirm" controlId="marketing_preferences_confirm" radios={this.optionsConfirm}/>
          </div>
          )}
      </div>
    );
  }
}


const mapStateToProps = state => ({
  ...state,
  marketingConsentText: state.marketingConsents.marketingConsent.content,
  marketingConsentCondition: state.marketingConsents.marketingConsent.condition
});


export default connect(mapStateToProps)(MarketingPreferences);



// WEBPACK FOOTER //
// ./src/components/about-you/marketing-preferences.jsx